import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUsersStates } from '../../../store';
import GridTable from './GridTable';

export const DoorAuthorization: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const { groupInformation } = useUsersStates();

  // Verkrijg de objecten die zijn ingeschakeld en bepaal het totaal aantal rijen
  const doors = groupInformation.objectsEnabled ?? [];
  const totalRows = doors.length;

  // Maak de titels voor de GridTable
  const titles = [
    t('group.door_authorization.column.door'),
    t('group.door_authorization.column.location'),
    t('group.door_authorization.column.module')
  ];

  // Maak de headertekst inclusief het totaal aantal rijen
  const header = `${t('group.door_authorization.content')} (Total Amount: ${totalRows})`;

  return (
    <GridTable
      header={header}
      titles={titles}
      rows={doors.map(it => ({
        doorName: it.doorName,
        doorLocation: it.doorLocation,
        moduleName: it.moduleName
      }))}
    />
  );
};
